import {LocationStrategy} from "@angular/common";
import {AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild, ViewContainerRef} from "@angular/core";
import {AppService} from "@api";
import {HeaderEnum, RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {Evaluacion} from "@modelo/global/Evaluacion.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";


@Component(
    {
        selector: 'evaluacionpendientecolaboradorintermedio',
        templateUrl: './colaboradorintermedio.component.html',
        styleUrls: ['./colaborador.component.scss']
    })

export class EvaluacionPendienteColaboradorIntermedioComponent implements AfterViewInit {
    consulta!: boolean;
    @Input() metodoevaluacion!: number;
    @Input() entidad!: Evaluacion;
    titulo!: string;
    @Output() output = new EventEmitter();

    listapreguntas: any[];
    objobservacion: any;

    public AlineacionImagenEnum = AlineacionImagenEnum;

    @ViewChild("evaluacioncomponent", {read: ViewContainerRef}) evaluacioncomponent!: ViewContainerRef;
    constructor(private appService: AppService, private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.entidad = new Evaluacion();
        this.listapreguntas = [];
    }

    ngAfterViewInit() {
        this.SetPreguntas();
    }

    Salir() {
        this.output.next();
    }

    SetPreguntas() {
        this.appService.Get("evaluacionpendiente/colaborador/pregunta/" + this.entidad.evaluacionpendientecolaboradorid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.listapreguntas = res.data.pregunta;
                this.objobservacion = res.data.observacion[0];
                if(this.listapreguntas.length > 0){
                    this.listapreguntas.map((pregunta: any) => {
                        pregunta.colortext = this.cambiarcolor(pregunta.color);
                    })
                }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "No se encuentran preguntas para esta evaluación");
                    this.output.next();
                }
            }else{
                this.output.next();
            }
        }).catch(err =>{
            this.output.next();
        })
    }

    cambiarcolor(color: any): string {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
        let val: any = [];
        if (result) {
            let r = parseInt(result[1], 16)
            let g = parseInt(result[2], 16)
            let b = parseInt(result[3], 16)
            val = this.rgbToHsl(r, g, b);
        }
        if (val[2] < 50) {
            return "colorblanco"
        } else {

            return "colornegro";
        }
    }

    rgbToHsl(r: any, g: any, b: any) {
        r /= 255;
        g /= 255;
        b /= 255;

        // Find greatest and smallest channel values
        let cmin = Math.min(r, g, b),
            cmax = Math.max(r, g, b),
            delta = cmax - cmin,
            h = 0,
            s = 0,
            l = 0;

        // Calculate hue
        // No difference
        if (delta == 0)
            h = 0;
        // Red is max
        else if (cmax == r)
            h = ((g - b) / delta) % 6;
        // Green is max
        else if (cmax == g)
            h = (b - r) / delta + 2;
        // Blue is max
        else
            h = (r - g) / delta + 4;

        h = Math.round(h * 60);

        // Make negative hues positive behind 360°
        if (h < 0)
            h += 360;

        // Calculate lightness
        l = (cmax + cmin) / 2;

        // Calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // Multiply l and s by 100
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);

        return [h, s, l];
    }

    sinterminar() {
        let opciones = this.sistemaService.GetOpcionesSalir();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Advertencia <br> se quedaron preguntas sin contestar. <br> ¿estas seguro de querer salir de la evaluación?', opciones).then(res => {
            if (res == 1) {
                this.consulta = true;
                this.output.next(this.consulta);
            }
        });
    }
    terminado() {
        this.appService.Post("evaluacionpendiente/colaborador", {"entidad": this.entidad, "evaluaciopendienteestatus": 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.consulta = true;
                this.output.next(this.consulta);
            }
        })
    }

    guardarcomentario(respuesta: any) {
        if (this.objobservacion.length > 0) {
            this.appService.Post("evaluacionpendiente/colaborador/guardarrespuesta", {"evaluacionpendienterespuestaid": this.objobservacion.evaluacionpendienterespuestaid, "observacion": respuesta}, [HeaderEnum.NoShowLoading]).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                }
            })
        } else {
            this.appService.Post("evaluacionpendiente/colaborador/guardarrespuesta", {"entidad": this.entidad, "observacion": respuesta}, [HeaderEnum.NoShowLoading]).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    if (res.data.observacion) {
                        this.objobservacion = res.data.observacion[0];
                    }
                }
            })
        }
    }

    guardarrespuesta(entidad:any){
        this.appService.Post("evaluacionpendiente/colaborador/guardarrespuesta",{"evaluacionpendienterespuestaid": entidad.evaluacionpendienterespuestaid,"tipopreguntaid":entidad.tipopreguntaid ,"escalaevaluacionvalorid": entidad.escalaevaluacionvalorid}, [HeaderEnum.NoShowLoading]).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
            }
        })
    }
}